import { render, staticRenderFns } from "./Im.vue?vue&type=template&id=4fe671e3&"
import script from "./Im.vue?vue&type=script&lang=js&"
export * from "./Im.vue?vue&type=script&lang=js&"
import style0 from "./Im.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports